import React from "react";
// import _ from "lodash";
// import FinalDesignTrend from "./FinalDesignTrend";
// import TrendCombinedChart from "./TrendCombinedChart";
// import TrendCombinedChartSynched_1 from "./TrendCombinedChartSynched_1";
import TrendCombinedChart from "./TrendCombinedChartFinal";

const fixedWidthStyle = { maxWidth: "1280px", margin: "auto" };

// V2
class TrendSection extends React.Component {
  render() {
    const {
      reports,
      selectedPubId,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      startDate,
      endDate,
      selectedCurrency,
      summaryData,
    } = this.props;

    return (
      <div style={fixedWidthStyle}>
        <div className="flex items-start justify-between">
          <div className="mb-4 text-2xl font-bold ">Performance Trend</div>
        </div>

        <TrendCombinedChart
          reports={reports}
          selectedPubId={selectedPubId}
          selectedNetworkId={selectedNetworkId}
          selectedYieldSetIds={selectedYieldSetIds}
          selectedRequestType={selectedRequestType}
          startDate={startDate}
          endDate={endDate}
          selectedCurrency={selectedCurrency}
          summaryData={summaryData}
        ></TrendCombinedChart>
      </div>
    );
  }
}

export default TrendSection;
